<div class="row">
  <div class="newPrePayOuter">
    <div class="newPrePayPage">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView" [ngClass]="{
    'col-md-9':orderViewtoggle == false,
    'col-md-12':orderViewtoggle == true}">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToPrePay()">Contracts</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>Request</span>
            </li>
          </ol>
        </nav>
      </div>
      <div class="prePayTop">
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="error && errorsList.length > 0">
              <div class="row">
                <div class="col-md-12">
                  <div class="inline-error" *ngIf="error">
                    <div class="row">
                      <div class="col-md-12 padding-l0">
                        <ol class="error-list">
                          <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                            {{err}}
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="search-box-inner material-select withBordr" [class.invalid-field]="prepayContractValidation.Account">
              <ng-select [items]="accountList"
                         [virtualScroll]="true"
                         [(ngModel)]="prePayRequestAccount"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         placeholder="Select Account"
                         (change)="accountChange($event)"
                         class="custom-select-grower"
                         (clear)="clearAccount()"
                         [searchFn]="accountSearchFn">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h5 *ngIf="item.accountNumber == item.parentNumber">
                          Parent
                        </h5>
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account#: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="search-box-inner material-select withBordr">
              <ng-select [items]="contractTypeList"
                         [virtualScroll]="true"
                         [(ngModel)]="prePayContractType"
                         bindLabel="item"
                         bindValue="item"
                         placeholder="Select Contract Type"
                         [clearable]="false"
                         (change)="contractTypeChange($event)"
                         class="custom-select-grower">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="preypaytab" *ngIf="contractTypeSelected">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 prepayRateSec" *ngIf="prePayContractType === 'SEED'">
            <h5>
              1. Select a Seed Prepay Program
            </h5>
            <div class="col-md-12 text-right smallPadLeft0 padding-r10">
              <div class="display-ib wAuto">
                <mat-paginator #seedPrePayPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]" (page)="pageEvent($event)"></mat-paginator>
              </div>
            </div>

            <div class="tableContainer growertableContainer">
              <table mat-table #seedPrePayTable [dataSource]="seedPrePayDataSource" matSort #seedPrePaySort matSortDirection="desc" class="matTables">
                <ng-container matColumnDef="prePaySupplierId">
                  <th mat-header-cell *matHeaderCellDef class="chkbox">&nbsp;</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-radio-button class="custom-radio" (change)="rateProgramChange(element)"></mat-radio-button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="supplierName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="branch">Prepay Supplier</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.supplierName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="prepayDueDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestedDate">Payment Due Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.prepayDueDate | date:'MM/dd/yyyy' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="gossUpPercentageRate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dealerReleaseNo">Gross Up Rate %</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.gossUpPercentageRate}}%
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="seedPrePayColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: seedPrePayColumns;"></tr>
              </table>
              <div *ngIf="seedPrePayList == undefined || seedPrePayList.length == 0" class="noDataMsg">
                <p>No Record Found.</p>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 prepayRateSec" *ngIf="prePayContractType === 'CPP'">
            <h5>1. Select a Crop Protection Prepay Program.</h5>
            <div class="table-outer">
              <div class="col-md-12 text-right smallPadLeft0 padding-r10">
                <div class="display-ib wAuto">
                  <mat-paginator #cropProtectionPrePayPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]" (page)="pageEvent($event)"></mat-paginator>
                </div>
              </div>

              <div class="tableContainer growertableContainer prepayRateTable">
                <table mat-table #cropProtectionPrePayTable [dataSource]="cropProtectionPrePayDataSource" matSort #cropProtectionPrePaySort matSortDirection="desc" class="matTables">
                  <ng-container matColumnDef="cropProtectionPrePaySupplierId">
                    <th mat-header-cell *matHeaderCellDef class="chkbox">&nbsp;</th>
                    <td mat-cell *matCellDef="let element">
                      <mat-radio-button class="custom-radio" (change)="rateProgramChange(element)"></mat-radio-button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="supplierName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="branch">Prepay Supplier</th>
                    <td mat-cell *matCellDef="let element">
                      <!--{{element.supplierName}}-->
                      {{element.descriptionOfPrepay}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="gossUpPercentageRate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="dealerReleaseNo">Gross Up Rate%</th>
                    <td mat-cell *matCellDef="let element">
                      {{element.gossUpPercentageRate}}%
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="prepayDueDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestedDate">Payment Due Date</th>
                    <td mat-cell *matCellDef="let element">
                      {{element.prepayDueDate | date:'MM/dd/yyyy' }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="cropProtectionPrePayColumns;sticky:true;"></tr>
                  <tr mat-row *matRowDef="let row; columns: cropProtectionPrePayColumns;"></tr>
                </table>
                <div *ngIf="cropProtectionPrePayList == undefined || cropProtectionPrePayList.length == 0" class="noDataMsg">
                  <p>No Record Found.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 prepayAmntSec">
            <div class="secondPt">
              <h5 *ngIf="prePayContractType === 'SEED'">
                2. Set your desired prepay amount.
              </h5>
              <h5 *ngIf="prePayContractType === 'CPP'">
                2. Set your desired crop protection prepay amount.
              </h5>

              <div *ngIf="prePayContractType === 'SEED'">
                <mat-form-field class="wide100" [class.invalid-field]="prepayContractValidation.PrepayAmount">
                  <label>Prepay Amount:</label>
                  <!--<input matInput type="text" name="prePayAmount"
                 [(ngModel)]="prePayAmount"
                 app-customcurrency
                 maxlength="11" appDecimalNumber (keyup)="validateInput(false)">-->
                  <input matInput currencyMask type="text" name="prePayAmount" class="newInput my-2"
                         [(ngModel)]="prePayAmount" autocomplete="off"
                         [options]="{ prefix: '$ ', thousands: ',', decimal: '.', precision: 2, align:'left', allowNegative: false }"
                         maxlength="18" placeholder="$ Enter Amount" (keyup)="validateInput(false)">
                </mat-form-field>
              </div>

              <div *ngIf="prePayContractType === 'CPP'">
                <mat-form-field class="wide100" [class.invalid-field]="prepayContractValidation.CropProtectionPrePayAmount">
                  <label>Crop Protection Prepay Amount:</label>
                  <!--<input matInput type="text" name="prePayAmount"
                 [(ngModel)]="cropProtectionPrePayAmount"
                 app-customcurrency
                 maxlength="11" appDecimalNumber (keyup)="validateInput(false)">-->
                  <input matInput currencyMask type="text" name="prePayAmount" class="newInput my-2"
                         [(ngModel)]="cropProtectionPrePayAmount" autocomplete="off"
                         [options]="{ prefix: '$ ', thousands: ',', decimal: '.', precision: 2, align:'left', allowNegative: false }"
                         maxlength="18" placeholder="$ Enter Amount" (keyup)="validateInput(false)">
                </mat-form-field>
              </div>

              <div *ngIf="prePayContractType === 'SEED'">
                <mat-form-field class="wide100">
                  <!--<input matInput [readonly]="true" [disabled]="true" [matDatepicker]="picker" (dateChange)="validatePrePayDate($event)" placeholder="Prepay Date" [(ngModel)]="prePayDate" (focus)="picker.open();" [matDatepickerFilter]="dateFilterPrePay">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>-->
                  <label>Prepay Date</label>
                  <input matInput [readonly]="true" [disabled]="true" [(ngModel)]="prePayDate" class="newInput my-2">
                </mat-form-field>
              </div>

              <div class="row" *ngIf="prePayContractType === 'CPP'">
                <div class="col-md-4 col-lg-3">
                  <label class="labelTxt">
                    Payment Type:
                  </label>
                </div>
                <div class="col-md-8 col-lg-9">
                  <div class="valueTypeBlock">
                    <mat-radio-group aria-label="Select an option">
                      <mat-radio-button value=" " class="first-radio" (change)="applyTypeChange(' ')">Manual</mat-radio-button>
                      <mat-radio-button checked value="Y" (change)="applyTypeChange('Y')">Auto</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>

              <div>
                <h5>
                  3. Review the terms and conditions and agree.
                </h5>
                <p class="smalltext">
                  Review the terms and conditions for this prepay attachment by clicking on the link
                  below. Then if you agree to the terms click on the checkbox stating that you agree in
                  order to submit the request.
                </p>
                <span class="donwloadPDF" (click)="downloadFile()">
                  <i class="fas fa-file-pdf"></i>
                  <small>Terms and Conditions</small>
                </span>
              </div>
              <div>
                <mat-checkbox #agreeTerms id="cbIsAgree" [disabled]="!isAgree" [checked]="termsSelected" class="custom-checkbox" (change)="termsConditionsClicked($event.checked)">
                  I agree to the terms and conditions.
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="prepayBtnSec">
      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button class="btns" [disabled]="!enableSubmit" *ngIf="!accessTypeMode" (click)="placeRequest()">Submit Request</button>
          <button mat-raised-button class="btns" *ngIf="!accessTypeMode" color="primary" (click)="navigateToPrePay()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
